<template>
	<div class="Box">
		<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisibleExplain" width="50%" :before-close="handleClose">
			<div style="width: 80%; margin: 0 auto">
				<el-table
					ref="multipleTable"
					:data="tableData"
					tooltip-effect="dark"
					style="width: 100%; text-align: center; margin-top: 10px"
					:header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }"
					size="medium"
					border
				>
					<el-table-column label="最小额(>)">
						<template slot-scope="scope">{{ scope.row.min }}</template>
					</el-table-column>
					<el-table-column label="最大额(<=)">
						<template slot-scope="scope">{{ scope.row.max }}</template>
					</el-table-column>
					<el-table-column label="回传规则">
						<template slot-scope="scope">{{ scope.row.rule }}</template>
					</el-table-column>
					<el-table-column label="x(回传笔数)">
						<template slot-scope="scope">{{ scope.row.x }}</template>
					</el-table-column>
					<el-table-column label="y(全部笔数)">
						<template slot-scope="scope">{{ scope.row.y }}</template>
					</el-table-column>
					<el-table-column label="z(回传金额比例)">
						<template slot-scope="scope">{{ scope.row.z }}</template>
					</el-table-column>
					<el-table-column label="说明" width="570">
						<template slot-scope="scope">{{ scope.row.explain }}</template>
					</el-table-column>
				</el-table>
				<div
					style="
						width: 100%;
						height: 160px;
						padding: 10px;
						background-color: #fafafa;
						border: 1px solid #ebeef5;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						margin-bottom: 20px;
					"
				>
					<p>说明：</p>
					<p style="margin-left: 35px">19.01-38.99额度范围回传（额度范围回传全部回传）</p>
					<p style="margin-left: 35px">39.01-40额度范围回传（额度范围外全部回传）</p>
					<p style="margin-left: 35px">50.01-1000（不在上面规则范围内，假设最大额度为1000）额度范围回传（额度范围外全部回传）</p>
					<p style="color: red">重点：未在规则内的额度全部回传</p>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ['dialogVisibleExplain'],
	components: {},
	data() {
		return {
			SearchFlag: false,
			title: '说明',

			tableData: [
				{ min: 0, max: '19', rule: '全部不回传', x: '不能填写', y: '不能填写',z:'不能填写', explain: '选择全部不回传则不能匹配回传笔数' },
				{ min: '38.99', max: '39', rule: '自定义', x: '3', y: '5',z:'0', explain: '39额度回传3笔漏掉2笔，最小额度和最大额度不可以相同，x和y不能为空' },
				{ min: '40', max: '50', rule: '自定义', x: '4', y: '5',z:'100', explain: '40.01-50额度范围回传4笔漏掉1笔' },
			],
		};
	},
	methods: {
		handleClose(done) {
			this.$emit('NoneDlogs');
		},
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep .el-dialog {
		.el-dialog__body {
			padding: 0 !important;
		}
	}
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>
